/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AddEditRoleType.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import CustomFormTextFieldV3 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV3";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";

import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions } from "../../../redux/actions";
import policiesActions from "../../../redux/actions/policiesActions";
import ChipsSelectField from "../../../components/customComponentsV2/common/select/ChipsSelectField";
import roletypeActions from "../../../redux/actions/roletypeActions";
function AddEditRoleType({
  open,
  title,
  onClose,
  selectedPolicyActions,
  setTriggerRoleType,
  selectedRoleType,
}) {
  const dispatch = useDispatch();
  const policies = useSelector((state) => state.policyReducer.policies);
  const [name, setName] = useState("");
  const [displayName, setdisplayName] = useState("");
  const [description, setdescription] = useState("");
  const [isActive, setisActive] = useState(true);
  const [policyDefIds, setpolicyDefIds] = useState("");
  const [selectedPolicies, setSelectedPolicies] = useState([]);

  useEffect(() => {
    dispatch(HandleApiActions({ ...policiesActions.get_policies,
      params: {
        limit: 100,
       offset:1
      }
     }));
  }, []);

  useEffect(() => {
    if (title.toUpperCase() === "UPDATE ROLETYPE") {
      setName(selectedRoleType?.roleType?.name);
      setdisplayName(selectedRoleType?.roleType?.display_name);
      setdescription(selectedRoleType?.roleType?.description);
      setisActive(selectedRoleType?.roleType?.is_active);
    }
  }, []);


  const listOfPolicies = useMemo(() => {
    return policies?.data?.policies;
  }, [policies?.data]);
  console.log("listOfPolicieslistOfPolicies", listOfPolicies);
  const handleClickAddDialog = () => {
    let reqObj = {
      name: name,
      display_name: displayName,
      is_active: isActive,
      ...(description?.trim() ? { description: description.trim() } : {}),
      ...(selectedPolicies?.length
        ? { policyDefIds: selectedPolicies?.map((data) => data?.value) }
        : {}),
    };
    dispatch(
      HandleApiActions({
        ...roletypeActions.add_roletype,
        params: reqObj,
        show_toast: true,
      }),
    ).then((resp) => {
      if (!resp?.error) {
        dispatch(
          HandleApiActions({ ...roletypeActions.get_all_roletype }),
        ).then(() => {
          onClose();
        });
      }
    });
  };
  const handleClickUpdateDialog = () => {
    let reqObj = {
      ...(displayName?.trim() ? { display_name: displayName } : {}),
      ...(isActive ? { is_active: isActive } : null),

      ...(description?.trim() ? { description: description.trim() } : {}),
    };
    dispatch(
      HandleApiActions({
        ...roletypeActions.update_roletype_meta,
        api_name: `/UCM/role-types/${selectedRoleType?.roleType?.role_type_id}`,
        params: reqObj,
        show_toast: true,
      }),
    ).then((resp) => {
      if (!resp?.error) {
        setTriggerRoleType(prev=>!prev)
        onClose();
      }
    });
  };

  const isFormValidAdd = useMemo(() => {
    return displayName?.trim();
  }, [displayName]);
  return (
    <div>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1.5 },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>

          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            mt: 2,
            maxHeight: "60vh",
            overflowY: "auto",
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#b0b0b0",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#888",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "8px",
            },
          }}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 1,
                width: "100%",
              }}
            >

              <>
                <CustomFormTextFieldV3
                  label="Display Name"
                  type="text"
                  required
                  fldType="text"
                  value={displayName}
                  setValue={setdisplayName}
                  placeholder="Enter Display Name"
                />

                <CustomFormTextFieldV3
                  label="Description"
                  required={false}
                  type="text"
                  fldType="text"
                  value={description}
                  setValue={setdescription}
                  placeholder="Enter Description"
                />
              </>
            </Box>
            {title.toUpperCase() === "ADD ROLE TYPE" ? (
              <Box>
                <Box>
                  <>
                    <Typography sx={{ fontWeight: 500, mb: 1 }}>
                      Select Policies
                    </Typography>

                    <ChipsSelectField
                      label="Policies"
                      placeholder="Select Policies"
                      selectedValue={policyDefIds}
                      setSelectedValue={setpolicyDefIds}
                      listValues={selectedPolicies}
                      setListValues={setSelectedPolicies}
                      optionsList={
                        listOfPolicies?.map((data) => ({
                          label: data?.policyName,
                          value: data?.policyId,

                          actions:
                            data?.domains_actions?.flatMap(
                              (d) => d?.actions || [],
                            ) || [],
                        })) || []
                      }
                    />
                  </>
                </Box>
              </Box>
            ) : null}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            borderTop: "1px solid #e0e0e0",
            pt: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <>
            <CustomButtonV2
              type="cancel"
              btnName="Cancel"
              handleOnClick={onClose}
            />
            <CustomButtonV2
              disabled={!isFormValidAdd}
              type="submit"
              btnName={
                title?.substring(0, 6).toLowerCase() === "update"
                  ? "Update Role Type"
                  : "Create Role Type"
              }
              handleOnClick={
                title?.substring(0, 6).toLowerCase() === "update"
                  ? handleClickUpdateDialog
                  : handleClickAddDialog
              }
            />
          </>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddEditRoleType;

AddEditRoleType.propTypes = {
  open: PropTypes.any,
  title: PropTypes.any,
  onClose: PropTypes.any,
  selectedPolicyActions: PropTypes.any,
  setTriggerRoleType: PropTypes.any,
  selectedRoleType: PropTypes.any,
};
